import { HttpBackend, HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HotToastService } from '@ngxpert/hot-toast';
import { forkJoin } from 'rxjs';

import { AppInitValues } from '@app/app-init-values';
import { StorageService } from '@common/storage.service';
import { environment } from '@environments/environment';
import { IdentityClientService } from '@identity/identity-client.service';
import { IdentityConstants } from '@identity/identity-constants.service';
import { SharedProvider } from '@shared/shared.provider';
import { SharedConstants } from '@shared/constants';

const IDENTITY_URL = environment.identityAPI;

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    httpBackend = inject(HttpBackend);
    storageService = inject(StorageService);
    http = inject(HttpClient);
    notification = inject(HotToastService);
    private constants = SharedConstants;
    private sharedProvider = inject(SharedProvider);

    loadConfig(): Promise<void> {

        this.sharedProvider.setDateInputFormat(this.constants.inputFormatDate);
        this.sharedProvider.setDateOutputFormat(this.constants.outputFormatDate);
        this.sharedProvider.setDateOutputLongFormat(this.constants.outputFormatDateDMMMY);

        return new Promise<void>((resolve, reject) => {
            const clientObj = new IdentityClientService(new IdentityConstants()).get();
            const client = clientObj !== undefined && clientObj.url !== undefined
                ? `${clientObj.url}`
                : window.location.pathname.split('/')[1] || '';

            let headers = new HttpHeaders();
            headers = headers.append('Content-Type', 'application/json');
            headers = headers.append('Access-Control-Allow-Origin', '*');
            headers = headers.append('Access-Control-Allow-Methods', 'POST,PATCH,OPTIONS');
            headers = headers.append('X-Product', AppInitValues.PRODUCT);
            headers = headers.append('X-Service', AppInitValues.INITIAL_SERVICE);

            this.httpBackend.handle(new HttpRequest('GET', `${IDENTITY_URL}/api/client/get?url=${client}`, headers))
                .subscribe({
                    next: (clientInfo: any) => {
                        const clientCode = clientInfo.body?.code ?? null;

                        if (clientCode !== null) {
                            this.storageService.set('sas-auth-client', clientCode);
                            this.storageService.set('sas-auth-current-client', JSON.stringify(clientInfo.body));
                            this.storageService.set('sas-auth-product', AppInitValues.PRODUCT);
                            this.storageService.set('sas-auth-service', AppInitValues.INITIAL_SERVICE);
                            headers = headers.append('X-Client', clientCode);

                            forkJoin({
                                clientConfig: this.http.get(`${IDENTITY_URL}/api/client/configuration`, { headers }),
                                serviceConfig: this.http.get(`${IDENTITY_URL}/api/service/configuration`, { headers })
                            }).subscribe({
                                next: (data: any) => {
                                    this.storageService.set('sas-auth-client-configuration', JSON.stringify(data.clientConfig));
                                    this.storageService.set('sas-auth-service-configuration', JSON.stringify(data.serviceConfig));

                                    resolve();
                                },
                                error: (err: any) => {
                                    console.error('Error loading configuration:', err);
                                }
                            });
                        }
                    },
                    error: (err: any) => {
                        this.notification.error(err.error[0].message ?? err.error.message);
                    }
                });
        });
    }

    getModuleConfig(client: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.httpBackend.handle(new HttpRequest('GET', `${IDENTITY_URL}/api/client/get?url=${client}`))
                .subscribe({
                    next: (clientInfo: any) => {
                        const clientCode = clientInfo.body?.code ?? null;

                        if (clientCode !== null) {
                            this.http.get(`${IDENTITY_URL}/api/service/configuration`, {})
                                .subscribe({
                                    next: (data: any) => {
                                        this.storageService.set('sas-auth-service-configuration', JSON.stringify(data));
                                        resolve();
                                    },
                                    error: (err: any) => console.error('Error loading configuration:', err)
                                });
                        }
                    },
                    error: (err: any) => {
                        this.notification.error(err.error[0].message ?? err.error.message);
                    }
                });
        });
    }
}
